import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-28">
          {/* Logo */}
          <Link to="/" className="flex items-center py-4">
            <img 
              src="https://static.readdy.ai/image/55261cfa04cdc3bd623a826c0ab805ee/a0d07c8a1a23a3822fdbccf2720ade94.png" 
              alt="Alta Care Home Health Logo" 
              className="h-24 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <Link 
              to="/" 
              className="font-medium text-gray-700 hover:text-[#0F5E26] transition-colors"
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className="font-medium text-gray-700 hover:text-[#0F5E26] transition-colors"
            >
              About Us
            </Link>
            <Link 
              to="/services" 
              className="font-medium text-gray-700 hover:text-[#0F5E26] transition-colors"
            >
              Services
            </Link>
            <Link 
              to="/contact" 
              className="font-medium text-gray-700 hover:text-[#0F5E26] transition-colors"
            >
              Contact
            </Link>
            <Link 
              to="/contact" 
              className="px-6 py-3 text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap"
              style={{ backgroundColor: '#0F5E26' }}
              onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#0a4a1e')}
              onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#0F5E26')}
            >
              Request Care
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-gray-900"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-6 bg-white border-t border-gray-200">
            <div className="flex flex-col gap-4">
              <Link 
                to="/" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-gray-700 font-medium py-2 hover:text-[#0F5E26]"
              >
                Home
              </Link>
              <Link 
                to="/about" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-gray-700 font-medium py-2 hover:text-[#0F5E26]"
              >
                About Us
              </Link>
              <Link 
                to="/services" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-gray-700 font-medium py-2 hover:text-[#0F5E26]"
              >
                Services
              </Link>
              <Link 
                to="/contact" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-gray-700 font-medium py-2 hover:text-[#0F5E26]"
              >
                Contact
              </Link>
              <Link 
                to="/contact" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-6 py-3 text-white font-semibold rounded-lg transition-all duration-300 text-center whitespace-nowrap"
                style={{ backgroundColor: '#0F5E26' }}
              >
                Request Care
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
